export default "__VITE_ASSET__dddc54c4__"